<template>
  <button
    ref="refRoot"
    class="button-arrow type-mono"
    :hovering="isHovering ? true : null"
  >
    <slot />
    <IconArrowForward class="icon" />
  </button>
</template>

<script setup lang="ts">
import IconArrowForward from "@/icons/arrow-forward-20.svg?component"

const props = defineProps({
  hovering: {},
})

const emits = defineEmits([])

const { $gsap, $ScrollTrigger } = useNuxtApp()

const { app, debug, browser } = useStores()

const refRoot = ref(null)

// *********************************************
// HOVERING
// *********************************************

const _hovering = useElementHover(refRoot)
const isHovering = computed(() => {
  if (props.hovering != undefined) return props.hovering
  return _hovering.value
})
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";

.button-arrow {
  @include flex(row, center, center);
  gap: 1rem;
}

.icon {
  width: 2rem;
  height: 2rem;
  transition: transform 0.3s ease-in-out;
}

.button-arrow[hovering] {
  .icon {
    transform: translateX(1rem);
  }
}
</style>
